export default __webpack_public_path__ + "static/media/G-Business.73cc7714.png";